var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 50,
    viewBox: "0 0 42 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.402954 2.73954C0.402954 1.58951 1.33011 0.662354 2.48014 0.662354H25.3648C26.5148 0.662354 27.442 1.58951 27.442 2.73954C27.442 3.88956 26.5148 4.81672 25.3648 4.81672H2.48014C1.33011 4.81672 0.402954 3.88956 0.402954 2.73954ZM0.402954 13.1433C0.402954 11.9932 1.33011 11.0661 2.48014 11.0661H25.3648C26.5148 11.0661 27.442 11.9932 27.442 13.1433C27.442 14.2933 26.5148 15.2205 25.3648 15.2205H2.48014C1.33011 15.2205 0.402954 14.2933 0.402954 13.1433ZM33.6824 13.1433C34.8325 13.1433 35.7596 14.0704 35.7596 15.2205V19.3837H39.9229C41.0729 19.3837 42.0001 20.3109 42.0001 21.4609C42.0001 22.6109 41.0729 23.5381 39.9229 23.5381H35.7596V27.7014C35.7596 28.8514 34.8325 29.7786 33.6824 29.7786C32.5324 29.7786 31.6053 28.8514 31.6053 27.7014V23.5381H27.442C26.2919 23.5381 25.3648 22.6109 25.3648 21.4609C25.3648 20.3109 26.2919 19.3837 27.442 19.3837H31.6053V15.2205C31.6053 14.0704 32.5324 13.1433 33.6824 13.1433ZM0.402954 23.547C0.402954 22.397 1.33011 21.4698 2.48014 21.4698H17.0382C18.1883 21.4698 19.1154 22.397 19.1154 23.547C19.1154 24.697 18.1883 25.6242 17.0382 25.6242H2.48014C1.33011 25.6242 0.402954 24.697 0.402954 23.547Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMore);
export default __webpack_public_path__ + "static/media/menu-more.816783e59530e551a6870e6de354d64d.svg";
export { ForwardRef as ReactComponent };